export default __webpack_public_path__ + "static/media/venky.179bf338.jpg";